import styled from "styled-components";

export const HomeWrapper = styled.div`
  .team-logo {
    position: fixed;
    top: 0;
    left: 0;
    max-width: 300px;
    img {
      width: 100%;
      height: auto;
    }
  }
`;

export const CAWrapper = styled.div`
  padding-top: 80px;
  padding-bottom: 80px;
  color: #fff;
  background: url("/assets/back.png") no-repeat;
  width: 100%;
  background-size: 100% 100%;
  /* text-align: center; */

  @media screen and (max-width: 1024px) {
    background: none;
    text-align: center;
    align-items: center;
  }
`;

export const AboutWrapper = styled.div`
  max-width: 1200px;
  width: 95%;
  display: flex;
  align-items: center;
  margin: 0 auto;
  gap: 72px;
  margin-bottom: 80px;
  text-align: start;
  @media screen and (max-width: 1024px) {
    gap: 36px;
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
`;

export const AboutImg = styled.div`
  img {
    background-size: contain;
    width: 140%;
    height: 100%;
    max-width: 600px;
  }

  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    img {
      width: 100%;
    }
  }

  @media only screen and (min-width: 1024px) and (max-width: 1199px) {
    img {
      width: 100%;
    }
  }

  @media only screen and (min-width: 1200px) and (max-width: 1440px) {
    img {
      width: 120%;
    }
  }

  @media only screen and (max-width: 767px) {
    img {
      width: 100%;
    }
  }
`;

export const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 50%;
  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
`;

export const AboutPin = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #e11d48;
`;

export const AboutHead = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 64px;
  @media screen and (max-width: 1024px) {
    font-size: 36px;
    line-height: 48px;
  }
`;

export const AboutDesc = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  @media screen and (max-width: 1024px) {
    font-size: 14px;
    line-height: 28px;
  }
  p:nth-child(1) {
    margin-bottom: 20px;
  }
`;

export const CollectionWrapper = styled.div``;

export const CollectionImage = styled.div`
  img {
    background-size: contain;
    width: 100%;
    height: auto;
  }
`;

export const CollectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 50%;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    align-items: center;
    text-align: center;
  }
`;

export const CollectionHead = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 64px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 1024px) {
    font-size: 36px;
    line-height: 48px;
  }
  @media screen and (max-width: 768px) {
    font-size: 28px;
    line-height: 36px;
  }
`;

export const CollectionDesc = styled.ul`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  list-style: "😀";
  padding-bottom: 8px;
  text-align: left;
  li {
    padding-left: 1rem;
    padding-bottom: 8px;
    /* text-indent: -0.7rem; */
  }
  @media screen and (max-width: 1024px) {
    font-size: 14px;
    line-height: 28px;
  }
`;
export const CollectionOutContainer = styled.div`
  max-width: 1200px;
  width: 95%;
  display: flex;
  position: relative;
  align-items: center;
  margin: 0 auto;
  gap: 72px;
  align-items: center;
  @media screen and (max-width: 1024px) {
    text-align: start;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;

    ${CollectionImage} {
      order: 2;
      margin-top: 20px;
    }

    ${CollectionContainer} {
      order: 1;
    }
  }
`;

export const CollectionPrice = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
  p:nth-child(1) {
    margin-bottom: 10px;
  }
`;

export const CollectionButton = styled.div`
  cursor: pointer;
  width: 290px;
  height: 60px;
  flex: none;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e11d48;
  border-radius: 6px;
  filter: drop-shadow(1px 1px 0px #772436);
  color: #e11d48;
  background-color: transparent;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 170%;
  transition: all 0.3s;
  user-select: none;
  &:hover {
    /* border: none; */
    color: #fff;
    background: #e11d48;
  }
`;

// Token Coming Soon
export const TokenComingSoonWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 925px;
  color: #fff;
  display: flex;
  align-items: center;

  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("assets/TokenComingSoonback.png");
    background-size: cover;
    filter: blur(10px); // Increase the value to increase the blur effect
    z-index: -1;
  }

  @media screen and (max-width: 768px) {
    height: 700px;
  }
  @media screen and (max-width: 320px) {
    height: 500px;
  }
`;

export const TokenComingSoonContainer = styled.div`
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 80px;
  img {
    width: 133.33px;
    height: auto;
    @media screen and (max-width: 768px) {
      width: 80px;
    }
  }
  p {
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 100%;
    @media screen and (max-width: 425px) {
      font-size: 24px;
    }
  }
`;

//membership coming soon

export const MembershipComingSoonWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 1000px;
  color: #fff;
  display: flex;
  align-items: center;

  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("assets/membershipbanner.png");
    background-size: cover;
    filter: blur(8px); // Increase the value to increase the blur effect
    z-index: -1;
  }

  @media screen and (max-width: 768px) {
    height: 700px;
  }
  @media screen and (max-width: 320px) {
    height: 500px;
  }
`;

export const MembershipComingSoonContainer = styled.div`
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 80px;
  img {
    width: 133.33px;
    height: auto;
    @media screen and (max-width: 768px) {
      width: 80px;
    }
  }
  p {
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 100%;
    text-align: center;
    @media screen and (max-width: 425px) {
      font-size: 24px;
    }
  }
`;
